import React, {Component} from 'react';
import moment from 'moment';
import _ from 'lodash';

import RangeDisplayText from './RangeDisplayText';
import {Button} from 'rsuite';
import Api from "util/Api";
import AlertToUIBadge from "util/AlertToUIBadge";
import {tooltip} from "components/Tooltips/WideRoomCardTooltip";
import {WhisperWrapper} from "components/Tooltips/WhisperWrapper";

const RoomStatusClass = [
    'badge badge-danger',
    'warning',
    'badge info',
    'unknown',
];

class WideRoomCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            alertStatus: props.active_alerts,
            now: Date.now(),
        };

        this.clearAlert = this.clearAlert.bind(this);
    }

    componentDidMount() {
        // Force to rerender every minute so the times update
        this.setState({
            rerenderTimer: setInterval(
                () => this.setState({now: Date.now()}),
                60 * 1000
            ),
        });
    }

    componentWillUnmount() {
        clearInterval(this.state.rerenderTimer);
    }

    clearAlert(alertId, comment) {
        Api.withAuth(this.props.auth)
            .postClearAlert(alertId, {
                staff_note: comment,
                staff_uid: this.props.auth.currentUser.profile.email,
            })
            .then(() => {
                const filterStatus = this.state.alertStatus.filter((stat) => {
                    return stat.id !== alertId;
                });
                this.setState({alertStatus: filterStatus});
            });
    }

    render() {
        const {props} = this;
        const {facility, section} = props.match.params;
        const {
            isVisited,
            minutesSinceLastVisit,
            room_name,
            wing,
            mv_status,
            last_visit,
            conditions,
        } = props;

        const patient = props.patient || {};
        const thresholds = _.cloneDeep(props.auth.facilityDetails.thresholds);
        _.merge(thresholds, props.thresholds);

        if (!props.patient_id) {
            return (
                <div className='col-md-4'>
                    <div
                        className='card'
                        onClick={() =>
                            this.props.history.push(
                                `/facilities/${facility}/sections/${section}/rooms/${props.id}`
                            )
                        }
                    >
                        <CardHeader name={room_name} wing={wing} atRisk={patient.atRisk}/>
                        <div className='card-body unoccupied d-flex align-items-center'>
                            <strong className='unoccupied'>Unoccupied</strong>
                        </div>
                    </div>
                </div>
            );
        }
        let visitTimeHoursPart = Math.floor(Math.abs(minutesSinceLastVisit) / 60)
            .toString()
            .padStart(2, '0');
        let visitTimeMinutesPart = Math.abs(minutesSinceLastVisit % 60)
            .toString()
            .padStart(2, '0');

        if (minutesSinceLastVisit < 0) {
            visitTimeHoursPart = '-' + visitTimeHoursPart;
        }

        if (!last_visit || isVisited) {
            visitTimeHoursPart = '--';
            visitTimeMinutesPart = '--';
        }
        let movementCount = 0;
        if (isVisited) {
            movementCount = -1;
        }

        let lastMovementText = 'UNKNOWN';
        if (mv_status) {
            if (mv_status.last_move) {
                lastMovementText = moment(mv_status.last_move * 1000).fromNow();
            }
            if (mv_status.value) {
                movementCount = mv_status.value;
            }
        }
        // Divide movement count in half to scale for number of bars in range display
        //movementCount /= 2;

        // const styles = {
        //     position: 'absolute',
        //     backgroundColor: 'gray',
        //     top: 'auto',
        //     left: 'auto',
        //     width: '100%',
        //     height: '100%',
        //     opacity: '.2',
        //     zIndex: 1000,
        //     textAlign: 'center',
        //     color: 'white',
        //     // display: 'none',
        // };
        const buttonStyle = {
            paddingLeft: '8px',
            paddingRight: '0px',
        };
        const spanStyle = {
            paddingLeft: '8px',
            paddingRight: '8px',
        };

        const alertBadges = this.state.alertStatus.map((currentStatus) => {
            return {id: currentStatus.id, ...AlertToUIBadge(currentStatus)};
        });

        return (
            <div className='col-md-4' key={props.card_key}>
                <WhisperWrapper
                    tooltip={tooltip}
                    props={{placement: "bottom", controlId: "control-id-hover", trigger: "hover"}}
                >
                    <div className='card'>
                        <CardHeader name={room_name} wing={wing} atRisk={patient.atRisk}/>
                        <div
                            className='card-body'
                            onClick={() =>
                                this.props.history.push(
                                    `/facilities/${facility}/sections/${section}/rooms/${props.room_id}/patient/${props.patient_id}`
                                )
                            }
                        >
                            <div className='patient-info'>
                                <div className='patient-avatar'>
                                    {props.photoUrl ? (
                                        <img alt='avatar' src={props.photoUrl}/>
                                    ) : (
                                        <span className='fa-stack fa-1x'>
                                          <i className='fas fa-circle fa-stack-2x'></i>
                                          <i className='fas fa-user fa-stack-1x fa-inverse'></i>
                                        </span>
                                    )}
                                    {props.patient_name}
                                    {props.patient && props.patient.chronic_condition && (
                                        <div
                                            style={{
                                                marginTop: -38 + 'px',
                                                marginLeft: 49 + 'px',
                                                marginBottom: -10 + 'px',
                                                fontWeight: 400,
                                                fontSize: 'smaller',
                                            }}
                                        >
                                            <div className='col'>{props.patient.chronic_condition}</div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className='visit-move-summary'>
                                <div className='visit-time'>
                                    <span className='label'>Since Last Visit</span>
                                    <div className='value'>
                                        <strong style={{fontSize: 20}}>{visitTimeHoursPart}</strong>
                                        {' '}H{' '}
                                        <strong style={{fontSize: 20}}>{visitTimeMinutesPart}</strong>
                                        {' '}M
                                    </div>
                                </div>

                                <div className='separator'/>

                                {/* <RangeDisplayText
                                    label='Movement Score'
                                    count={movementCount}
                                    lastLabel={`Last Move: ${lastMovementText}`}
                                /> */}
                            </div>
                        </div>
                        <div className='aggregate-room-status'>
                            {alertBadges.map((alert, index) => (
                                <Button  key={index} appearance="subtle" style={buttonStyle}>
                                    <span className={'badge ' + alert.level} style={spanStyle}>{alert.message}</span>
                                </Button>
                            ))}
                            {conditions &&
                                conditions.map((condition, index) => (
                                    <Button key={index} style={buttonStyle} appearance='subtle'>
                                        <span style={spanStyle} className={RoomStatusClass[2]}>
                                            {condition}
                                        </span>
                                    </Button>
                                ))}
                        </div>
                    </div>
                </WhisperWrapper>
            </div>
        );
    }
}

const CardHeader = ({name, wing, atRisk}) => (
    <div className='card-header d-flex justify-content-between'>
    <span>
      {name}
        {wing && <small>- {wing}</small>}
    </span>
        {atRisk && <i className='fas fa-star'/>}
    </div>
);

export default WideRoomCard;
